import { Navigate, Outlet, useLocation } from "react-router-dom";
import { CookieManager } from "@repo/auth-sdk";
import { User } from "../../services";
import TIGLogoWhite from "@repo/ui/src/assets/images/TIG_LOGO_WHITE.svg";

export function AuthLayout() {
  const location = useLocation();

  if (location?.pathname === "/" || location?.pathname === "") {
    return <Navigate to="/login" />;
  }

  let initialToken = "";
  let initialUser = null;

  try {
    initialToken = CookieManager.getAccessToken() || "";
    initialUser = CookieManager.getUserInfo() as unknown as User;
  } catch {
    // Cookie manager not configured — continue with auth flow
  }

  if (initialUser && initialToken) {
    window.location.replace(initialUser.redirectUrl);
  }

  return (
    <div className="flex h-screen">
      {/* ── Left brand panel ── */}
      <div
        className="hidden lg:flex lg:w-5/12 xl:w-2/5 flex-col justify-between p-12 relative overflow-hidden"
        style={{
          background: "linear-gradient(145deg, #3D52A0 0%, #2B3B73 100%)",
        }}
      >
        {/* Decorative circles */}
        <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-white/5" />
        <div className="absolute top-1/3 -right-20 w-56 h-56 rounded-full bg-white/5" />
        <div className="absolute -bottom-10 left-1/4 w-80 h-80 rounded-full bg-white/5" />

        <img
          src={TIGLogoWhite}
          alt="The Immigurus"
          className="w-36 relative z-10"
        />

        <div className="relative z-10">
          <p className="text-white/50 text-sm uppercase tracking-widest mb-3 font-semibold">
            Portal Suite
          </p>
          <h1
            className="text-white font-bold leading-tight mb-4"
            style={{ fontSize: "2rem" }}
          >
            Your immigration
            <br />
            operations hub
          </h1>
          <p className="text-white/60 text-md leading-relaxed">
            Manage leads, counsellors, teams and documents — all from one
            unified platform.
          </p>
        </div>

        <p className="text-white/30 text-sm relative z-10">
          © {new Date().getFullYear()} The Immigurus. All rights reserved.
        </p>
      </div>

      {/* ── Right content panel ── */}
      <div className="flex flex-1 bg-background-light">
        <Outlet />
      </div>
    </div>
  );
}
